import pipe from 'lodash/fp/pipe'
import * as Redux from 'redux'
import {filterObject} from '../../app/constants'
import * as Router from '../../router/constants'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

export type InitialValues<T> = Types.Fields<T>
export type IsDirty = boolean
export type IsEditing = boolean
export type IsSaving = boolean
export type IsValid = boolean
export interface State<T> {
  fields: Types.Fields<T>,
  isDirty: IsDirty,
  isEditing: IsEditing,
  isSaving: IsSaving,
  initialValues: InitialValues<T>,
  isValid: IsValid,
}

const staticInitialFormState: State<{}> = {
  fields: {},
  initialValues: {},
  isDirty: false,
  isEditing: false,
  isSaving: false,
  isValid: false,
}
interface Args<T> {
  constants: {[key: string]: string},
  initialFieldValues: T,
  useParams: boolean
}

type ReducerAction = Actions.Actions<any> & {urlParams: {}}
const createFormReducer = <T>({constants, initialFieldValues, useParams}: Args<T>) =>
  (state: State<T>, action: ReducerAction) => {
    const initialFormState = initialFieldValues ? {
      ...staticInitialFormState,
      fields: initialFieldValues,
    } : staticInitialFormState
    switch (action.type) {
      case constants[Constants.RESET]:
        return initialFormState
      case constants[Constants.CANCEL]:
      case constants[Constants.EXIT]:
        return {
          ...initialFormState,
          fields: state.initialValues,
        }
      case constants[Constants.ENTER]:
        return {
          ...initialFormState,
          fields: {
            ...action.value,
          },
          initialValues: {
            ...action.value,
          },
          isEditing: true,
        }
      case constants[Constants.SAVE]:
        return {
          ...state,
          isSaving: true,
        }
      case constants[Constants.SAVE_COMPLETE]:
        return {
          ...state,
          isSaving: false,
        }
      case constants[Constants.VALIDATE]:
        return {
          ...state,
          isValid: Boolean(action.value),
        }
      case constants[Constants.UPDATE]:
        return {
          ...state,
          isDirty: true,
          ...{
            fields: {
              ...state.fields,
              [action.value.name]: action.value.value,
            },
          },
        }
      case Router.ON_ENTER:
        if (useParams) {
          return {
            ...state,
            fields: {
              ...state.fields,
              ...filterObject(action.urlParams, state.fields),
            },
          }
        } else {
          return state
        }
      default:
        return state || initialFormState
    }
}

type CreateReducer = (prefix: Constants.FormPrefix, initialFieldValues?: {}, useParams?: boolean) => Redux.Reducer<{}>
export const createReducer: CreateReducer = pipe(
  (prefix: Constants.FormPrefix, initialFieldValues: {} = null, useParams = false) => ({
    constants: Utils.createConstantsMap(prefix),
    initialFieldValues,
    useParams,
  }),
  createFormReducer,
)



// WEBPACK FOOTER //
// ./src/components/form/reducer.ts